// Angular
import { Component } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
// Service
import { BroadcastService, ToasterType } from '@cv-invision/core';
import { NexsysMonitorService } from '../../service/nexsys-monitor.service';
// Others
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
	selector: 'cv-nexsys-orphan-custom-action-read',
	templateUrl: './custom-action-nexsys-orphan-read.component.html',
	styleUrls: ['./custom-action-nexsys-orphan-read.component.scss']
})
export class CustomActionNexsysOrphanReadComponent implements ICellRendererAngularComp {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;

	constructor(
		private nexsysMonitorService: NexsysMonitorService,
		private broadcastService: BroadcastService,
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Mark read unread
	 */
	markReadUnread(markAsReadUnread: boolean): void {		
		this.nexsysMonitorService
			.markOrderLogAsReadUnread(this.cellValue.transactionId, {isRead: markAsReadUnread})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result.successed) {
						this.nexsysMonitorService.reloadList({ reload: true });
						const message = markAsReadUnread ? 'Log marked as read.' : 'Log marked as unread.';
						this.broadcastService.broadcast({
							name: ToasterType.SUCCESS,
							event: { message }
						});
					}
				},
				error => {
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: { error }
					});
				}
			);
	}

	/**
	 * Stop Propagation
	 */
	stopPropagation($event: any): void {
		$event.stopPropagation();
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
